<template>
  <div class="Obs_info" align="" style="width:80%">
    <div v-if="data">
      <div class="title" :inline="true">
        <el-form >
          <el-form-item :label="`${$t('ObsInfo.title')}`"  >          
          </el-form-item>
        </el-form>
      </div>
      <el-divider></el-divider>
      <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a  href="/">{{$t('navBar.goback')}}</a> 
        </el-breadcrumb-item>
        <!-- <el-breadcrumb-item>
            <router-link v-bind:to="`/infotarget/`+data.id">{{$t('TargetInfo.title')}}</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
            <router-link v-bind:to="`/infoproposal/`+data.id">{{$t('ProposalInfo.title')}}</router-link>
        </el-breadcrumb-item> -->
      </el-breadcrumb>
      <div class="container" v-if="data">
        <el-form :inline="true" :model="ObsInfoForm" class="search-form">

          <el-form-item label="ID" v-if="false">
            <el-input size="mini" v-model="data.id" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>

          <el-form-item :label="$t('proposal.obs_id')">
            <el-input size="mini" v-model="data.obs_id" autocomplete="off" :disabled="true" ></el-input>
          </el-form-item>

          <el-form-item :label="$t('proposal.schedule_id')">
            <el-input size="mini" v-model="data.schedule_id" autocomplete="off" :disabled="true" ></el-input>
          </el-form-item>

          <el-form-item :label="$t('proposal.tstart')">
            <el-input size="mini" v-model="data.tstart" autocomplete="off" :disabled="true" ></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.tsop')">
            <el-input size="mini" v-model="data.tsop" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.start_utc')">
            <el-input size="mini" v-model="data.start_utc" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.stop_utc')">
            <el-input size="mini" v-model="data.stop_utc" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.duration')">
            <el-input size="mini" v-model="data.duration" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.pre_slew')">
            <el-input size="mini" v-model="data.pre_slew" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.post_slew')">
            <el-input size="mini" v-model="data.post_slew" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item :label="$t('proposal.target')" v-if="true">
            <div >
              <a :href="`/infotarget/`+data.id" class="logout-link" >{{data.target}}</a>
            </div>
          </el-form-item>


          <!-- <el-form-item :label="$t('proposal.target')" v-if="true">
            <el-input size="mini" v-model="data.target" autocomplete="off" :disabled="true" v-if="true"></el-input>
          </el-form-item> -->
          <el-form-item :label="$t('proposal.obs_mode')">
            <el-input size="mini" v-model="data.obs_mode" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.data_mode')">
            <el-input size="mini" v-model="data.data_mode" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.proposal')" v-if="true">
            <div >
              <a :href="`/infoproposal/`+data.id" class="logout-link" >{{data.proposal}}</a>
            </div>
          </el-form-item>
          <!-- <el-form-item :label="$t('proposal.proposal')" v-if="true">
            <el-input size="mini" v-model="data.proposal" autocomplete="off" :disabled="true"  v-if="true"></el-input>
          </el-form-item> -->
          <el-form-item :label="$t('proposal.observer')" v-if="true">
            <el-input size="mini" v-model="data.observer" autocomplete="off" :disabled="true"  v-if="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.ptype')" v-if="true">
            <el-input size="mini" v-model="data.ptype" autocomplete="off" :disabled="true"  v-if="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.status')">
            <el-input size="mini" v-model="data.status" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.ra')" v-if="false">
            <el-input size="mini" v-model="data.ra" autocomplete="off" :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.dec')" v-if="false">
            <el-input size="mini" v-model="data.dec" autocomplete="off"  :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.speed')" v-if="obs_mode_isP">
            <el-input size="mini" v-model="data.speed" autocomplete="off" :disabled="true" v-if="obs_mode_isP"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.interval')" v-if="obs_mode_isP">
            <el-input size="mini" v-model="data.interval" autocomplete="off" :disabled="true" v-if="obs_mode_isP"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.radius')" v-if="obs_mode_isP">
            <el-input size="mini" v-model="data.radius" autocomplete="off"  :disabled="true" v-if="obs_mode_isP"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.offset')">
            <el-input size="mini" v-model="data.offset" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.owner')">
            <el-input size="mini" v-model="data.owner" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.isopenstate')">
            <!-- <el-input size="mini" :v-model="$t(`proposal.isopen_data.${data.isopen}`)" autocomplete="off" style="width:200px;" :disabled="true"></el-input> -->
            {{$t(`proposal.isopen_data.${data.isopen}`)}} 
          </el-form-item>
          <el-form-item :label="$t('proposal.archive_time')">
            <el-input size="mini" v-model="data.archive_time" autocomplete="off" style="width:200px;" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.release_time')">
            <el-input size="mini" v-model="data.release_time" autocomplete="off" style="width:200px;" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item v-if="data.isopen" :label="$t('proposal.open_time')">
            <el-input size="mini" v-model="data.open_time" autocomplete="off" style="width:200px;" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.l1_file_v')">
            <el-input size="mini" v-model="data.l1_file_id" autocomplete="off" style="width:200px;" :disabled="true"  placeholder="暂无"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.l15_file_v')">
            <el-input size="mini" v-model="data.l15_file_id" autocomplete="off" style="width:200px;" :disabled="true" placeholder="暂无"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.l2_file_v')">
            <el-input size="mini" v-model="data.l2_file_id" autocomplete="off" style="width:200px;" :disabled="true" placeholder="暂无"></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.create_time')" v-if="false">
            <el-input size="mini" v-model="data.create_time" autocomplete="off" style="width:200px;" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <!-- <el-form-item :label="$t('proposal.create_by')">
            <el-input size="mini" v-model="data.create_by" autocomplete="off" style="width:200px;" :disabled="true"></el-input>
          </el-form-item> -->
          <el-form-item :label="$t('proposal.update_time')"  v-if="false">
            <el-input size="mini" v-model="data.update_time" autocomplete="off" style="width:200px;" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <!-- <el-form-item :label="$t('proposal.update_by')">
            <el-input size="mini" v-model="data.update_by" autocomplete="off" style="width:200px;" :disabled="true"></el-input>
          </el-form-item> -->
      
      
        </el-form>
        <el-divider></el-divider>
        <div class="image-content">
          <div v-for="(item, i) in imagefile" :key="i">
            <div>
              <span>{{ language === 'zh' ? item.zhinfo : item.eninfo}}</span>
            </div>
            <div>
              <img class="img-view"  :src="`/iapi/images/${id}/${item.file}`">
            </div>           
          </div>
        </div>
        <div align="right">
          <!-- <el-button size="mini" @click="chiefverno" :disabled="true">拒绝(refuse)</el-button>
          <el-button size="mini" type="primary" @click="chiefverok" :disabled="true">同意(OK)</el-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  name: 'ObsInfo',
  props: {
    id: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      data: null,
      obs_mode_isP:true,
      ObsInfoForm:{
      },
      imagefile:[],
    };
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapState([
      'userInfo',
      'language',
    ]),
  },
  methods: {
    getData() {
      const params = {
        id : this.id,
        pic:1,
      }
      
      axios.post('/iapi/InfoObs', params).then((res) => {
        if (res.data.errcode === 0) {
          this.data = res.data.data;
          this.imagefile = res.data.files;
          if(this.data.obs_mode==='P'){
            this.obs_mode_isP = false;
          }
          // console.log('data',this.imagefile);
        } else {
          this.$message.error('数据不存在');
        }
      });
    },
    onSubmit() {
      this.getData();
    },
  },
};
</script>

<style scoped>

.Obs_info{
  padding: 24px 56px;
  margin:0 auto;
}
.title {
  margin-right: 56px;
  font-size: 40px;
  color: #fff;
  font-weight: 50;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 5px;
    margin-bottom: 5px;
}
.admin-path {
  margin-bottom: 30px;
  color: blue;
}
.image-content {
  text-align: center;
}
.img-view {
  max-width: 100%;
  margin: 2px auto;
}
</style>
